import type { CountryCode } from 'libphonenumber-js';

const env = import.meta.env;

export const useEmulators = env.VITE_USE_EMULATORS === 'true';

/** Set by CI from Terraform once Google Analytics is linked to the Firebase project. */
export const measurementId = env.VITE_FIREBASE_MEASUREMENT_ID?.trim() ?? '';

/** Analytics can be offered: a real project with Analytics linked. Each browser still has to allow it. */
export const analyticsConfigured = !useEmulators && measurementId !== '';

export const shopName = env.VITE_SHOP_NAME?.trim() || 'Client catalogue';

export const defaultPhoneCountry = (env.VITE_DEFAULT_PHONE_COUNTRY?.trim().toUpperCase() ||
  'HU') as CountryCode;

/** Renewal dates this many days ahead are flagged as "due soon". */
export const RENEWAL_SOON_DAYS = 30;

/** The renewals screen also shows dates that passed up to this many days ago. */
export const RENEWAL_LOOKBACK_DAYS = 90;
